<template>
  <div class="references"> 
    <div>
      &nbsp;<toggle-button v-if="!isEditing" v-bind:isHidden="isHidden" @show="show()" @hide="hide()" />
      <button @click="isHidden?show():hide()" type="button" class="w3-button" style="margin:0px; padding:0px">
        <span style="font-weight:bold">&nbsp;{{label}}:</span> 
      </button> 
      <edit-button v-if="isEditable" v-bind:isEditing="isEditing" @edit="edit()" @done="$emit('addReference'); stopEdit()" />
    </div>
    <div v-if="isEditing">
      <input @keyup.enter="$emit('addReference')" type="text" name="urlReference" placeholder="URL" v-model="model.meta.newUrl" class="w3-left w3-margin-right" style="width: 100%; margin-bottom: 5px">
      <br />
      <input @keyup.enter="$emit('addReference')" type="text" name="urlDesc" placeholder="DESCRIPTION" v-model="model.meta.newDesc" class="w3-margin-bottom" style="width: 100%">
      <br />
    </div>
    <div v-if="!isHidden || isEditing" v-for="(reference, index) in references" class="w3-medium w3-border w3-round"> 
      <div v-if="reference.description">
        <span v-if="!reference.url">{{reference.description}} &nbsp;</span> 
        <button v-if="isEditing" @click="$emit('removeReference', reference)" type="button" class="w3-button w3-text-theme" style="padding:0"><i class="far fa-times-circle"></i></button>
      </div>
      <div v-if="reference.url">
        <reference-preview :reference="reference"></reference-preview>
      </div>
    </div>
  </div>
</template>

<script>
  import References from './References.ts';

  export default References
</script>
